<template>
    <section class="journey-planner">
        <div class="container">
            <h3 class="journey-planner-title">
                <span class="journey-planner-title__label">
                    <journey-icon></journey-icon>Journey Planner
                </span>
                <div class="journey-planner-title__actions">
                    <a class="help-link" :href="help"><span>?</span>Help</a>
                </div>
            </h3>
            <div class="journey-planner__container">
                <shortlist></shortlist>
                <trip :servertrip="servertrip"></trip>
            </div>
        </div>
    </section>
    <popular-trips></popular-trips>
</template>
<script>
import { updateIndicator } from "@/components/shortlist.js";
import { useShortlistStore } from "@/vue/stores/shortlist.js";
import { usePopularStore } from "@/vue/stores/popular.js";
import { useTripStore } from "@/vue/stores/trip.js";
import JourneyIcon from "@/vue/icons/JourneyIcon";
import Shortlist from "@/vue/components/Shortlist.vue";
import Trip from "@/vue/components/Trip.vue";
import PopularTrips from "@/vue/components/PopularTrips";
import Confirmation from "@/vue/components/Confirmation";

export default {
    components: {
        JourneyIcon,
        PopularTrips,
        Shortlist,
        Trip,
    },
    props: {
        help: String,
        servertrip: Array,
        popular: Array,
    },
    data() {
        return {
            shortlist: useShortlistStore(),
            trip: useTripStore(),
            filterDays: null,
        };
    },
    created() {
        const popular = usePopularStore()
        popular.setup(this.popular)
    },
    mounted() {
        updateIndicator();
    },
    methods: {
        handleConfirm: function (input) {
            this.trip.replaceData(input);
        },
        handleCancel: function () {
            // this.$bus.emit("modal-close");
        },
        handleAddJourney: function (input) {
            this.$bus.emit("modal-open", Confirmation, {
                message: "This will overwrite your current journey.",
                options: [
                    {
                        text: "Yes - Overwrite my journey",
                        classList: "button-solid-dark",
                        handler: this.handleConfirm,
                        args: input,
                    },
                    {
                        text: "Cancel - Keep my current journey",
                        classList: "button-solid-red",
                        handler: this.handleCancel,
                    },
                ],
            });
        },
    },
};
</script>
